import { useSystemStore, type I18 } from './stores/system';
import { createApp, watch } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import App from './App.vue'
import router from './router'

import './assets/main.css'
import './assets/mapbox.css'
import i18nInstance, {locale, t} from '@/locale'
import globalUI from "./plugins/global-ui"
import directive from './plugins/directive'
const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)
app.use(router)
app.use(i18nInstance);
app.use(globalUI);
app.use(directive);
app.mount('#app');


const systemStore = useSystemStore();

locale.value = systemStore.currentI18;
// 刷新之后重新赋值title
document.title = '北京天桥艺术中心购票官网'
watch(() => systemStore.currentI18,() => {
  document.title = `${t('system.title')}`
})

router.beforeEach((guard) => {
  const { query: { lang }} = guard;
  if ( lang && ["en","zh"].includes(lang as string)) {
    locale.value = 'zh-CN';
    systemStore.toggleSetting('I18', locale.value as I18);
  }
  systemStore.toggleSetting('LoginDialog', false);
  systemStore.toggleNavPath(guard.fullPath);
});

